import { __objRest, __spreadProps, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/components/Stepper/Stepper.Node.tsx
import { forwardRef } from "react";
import { clsx } from "clsx";
import { jsx, jsxs } from "react/jsx-runtime";
var DEFAULT_COMPONENT = "div";
var STEPPER_NODE_CLASSNAME_MAP = {
  variant: {
    default: "pd-stepper__node--default",
    primary: "pd-stepper__node--primary",
    disabled: "pd-stepper__node--disabled",
    success: "pd-stepper__node--success"
  }
};
var StepperNode = forwardRef((_a, ref) => {
  var _b = _a,
    {
      as,
      variant = "default",
      children,
      secondaryLabel,
      className
    } = _b,
    rest = __objRest(_b, ["as", "variant", "children", "secondaryLabel", "className"]);
  const Component = as || DEFAULT_COMPONENT;
  return /* @__PURE__ */jsx(Component, __spreadProps(__spreadValues({
    ref,
    className: clsx("pd-stepper__node", STEPPER_NODE_CLASSNAME_MAP.variant[variant], className)
  }, rest), {
    children: /* @__PURE__ */jsxs("div", {
      className: "pd-stepper__labels",
      children: [/* @__PURE__ */jsx("span", {
        className: "pd-stepper__label",
        children
      }), secondaryLabel && /* @__PURE__ */jsx("span", {
        className: "pd-stepper__secondary-label",
        children: secondaryLabel
      })]
    })
  }));
});
var Stepper_Node_default = StepperNode;
export { Stepper_Node_default };